import React from "react";
import { Typography, Row, Col } from "antd";

const { Title, Paragraph } = Typography;

function AboutUs() {
  return (
    <Row justify="center" className="py-5">
      <Col xs={22} sm={20} md={16} lg={14}>
        <Title level={2}>About Us</Title>
        <Paragraph>
          Welcome to Pic Forest, the ultimate destination for high-quality
          wallpapers that will breathe new life into your digital devices! Our
          mission is to provide you with a vast selection of beautiful and
          inspiring wallpapers that suit your individual style and personality.
        </Paragraph>
        <Paragraph>
          At Pic Forest, we believe that your digital devices should reflect
          your unique taste and preferences. That's why we've curated a
          collection of wallpapers that cater to all styles and moods. Whether
          you're looking for stunning nature landscapes, colorful abstract
          designs, or cute animal illustrations, we've got you covered.
        </Paragraph>
        <Paragraph>
          We understand that finding the perfect wallpaper can be a
          time-consuming and frustrating process. That's why we've made it easy
          for you to browse and search for wallpapers on our website. You can
          search by category, color, resolution, and even by your favorite
          artists.
        </Paragraph>
        <Paragraph>
          Our team is passionate about wallpapers and strives to provide you
          with the best possible experience. We're constantly updating our
          collection with new and exciting wallpapers, so be sure to check back
          often for fresh inspiration.
        </Paragraph>
        <Paragraph>
          At Pic Forest, we're committed to providing you with a seamless and
          enjoyable experience. If you have any questions or feedback, don't
          hesitate to contact us. We'd love to hear from you!
        </Paragraph>
        <Paragraph>
          Thank you for choosing Pic Forest for your wallpaper needs. We hope
          our wallpapers will inspire you and brighten up your day.
        </Paragraph>
      </Col>
    </Row>
  );
}

export default AboutUs;
